module.exports = __webpack_public_path__ + "assets/icons/my-job.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/my-job.png
// module id = ./src/styles/icons/sidemenu/my-job.png
// module chunks = 0